import { useState } from 'react';
import { ActionButton, Dialog, toast } from '@components';
import { useRecoilState } from 'recoil';
import { RateCard as RateCardState } from '@state';
import { useDeleteCPIIncrease } from '@api/RateCards/cpiIncreaseApis.ts';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

export const CPIIncreaseDeleteButton = ({ isDisabled }: {isDisabled: boolean}) => {
	const [open, setOpen] = useState(false);
	const [rateCard, setRateCard] = useRecoilState(RateCardState);
	const { callDeleteCPIIncrease, isLoading: isDeleting } = useDeleteCPIIncrease();

	if (!rateCard?.latest_cpi_increase) {
		return null;
	}
	const cpiIncrease = rateCard?.latest_cpi_increase;

	const handleSubmit = async () => {
		await callDeleteCPIIncrease(cpiIncrease.id).then(() => {
			toast.success('CPI increase updated successfully.');
			setRateCard((prev) => prev ? {
				...prev,
				latest_cpi_increase: undefined,
			} : prev);
			setOpen(false);
		}).catch((err: Error) => {
			const errorData = (err.cause as any)?.response?.data;
			toast.error(errorData?.message || err.message || 'An error occurred while updating the CPI increase.');
		});
	};
	return (
		<>
			<ActionButton
				text={'Remove CPI increase'}
				Icon={DeleteOutlinedIcon}
				iconOnly
				iconActiveColor='var(--func-red-default)'
				onClick={() => setOpen(true)}
				disabled={isDisabled}
			/>
			<Dialog
				open={open}
				onClose={() => setOpen(false)}
				title={'Remove this CPI Increase?'}
				text={'You are about to remove the scheduled CPI increase for this rate card.'}
				actionButtonText={'Remove Increase'}
				actionButtonFn={handleSubmit}
				actionButtonLoading={isDeleting}
				closeOnButtonAction={false}
				closeOnClickOutside={false}
				closeOnEscape={true}
			/>
		</>
	);
};
